import Vue from 'vue';

class AuthService {

  constructor() {
    this.ROLES = [
      {
        id: 0,
        name: 'superadmin'
      },
      {
        id: 1,
        name: 'company_admin'
      },
      {
        id: 2,
        name: 'unit_admin'
      },
      {
        id: 3,
        name: 'office_admin'
      },
      {
        id: 4,
        name: 'operator'
      },
      {
        id: 5,
        name: 'senior_operator'
      }
    ];
  }

  login(access_token, refresh_token, user) {
    localStorage.setItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN, access_token);
    localStorage.setItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.REFRESH_TOKEN, refresh_token);
    localStorage.setItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.USER, JSON.stringify(user));

    Vue.prototype.$store.user = user;
  }

  clearUser() {
    localStorage.removeItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN);
    localStorage.removeItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.REFRESH_TOKEN);
    localStorage.removeItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.USER);
    if (Vue.prototype.$store && Vue.prototype.$store.hasOwnProperty('user')) Vue.prototype.$store.user = null;
  }

  logoutRequest() {
    Vue.prototype.$crudService.post('logout').then(() => {
      this.clearUser();
      Vue.prototype.$ticketService.clearAutoCallTimer();
      Vue.prototype.$socketService.close();
    })
  }

  logout() {
    return new Promise((res, rej) => {
      if (Vue.prototype.$store.currentTicketServicing) {
        Vue.prototype.$ticketService.closeTicket(Vue.prototype.$store.currentTicketServicing, Vue.prototype.$store.currentTicketTags.map(tag => tag.id)).then(() => {
          Vue.prototype.$store.ticketTransactionEnd = true;
          this.logoutRequest();
          res()
        })
      } else {
        this.logoutRequest();
        res()
      }
    })
  }

  refresh() {
    return new Promise((res, rej) => {
      const refreshToken = localStorage.getItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.REFRESH_TOKEN);
      const token = localStorage.getItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN);
      if (refreshToken && token) {
        Vue.prototype.axios.post(`${Vue.prototype.$deviceConfig.API_URL}/api/refresh?refresh_token=${refreshToken}`, {}, {
          headers: {
            'token': token
          }
        }).then((response) => {
          res(response)
        }).catch((err) => {
          rej(err)
        })
      } else {
        rej()
      }
    })
  }

  getRole(user) {
    return user && user.hasOwnProperty('role_id') ? this.ROLES.find(role => role.id === user.role_id) : {}
  }

  updateUser(name, surname, phone) {
    const currentUser = JSON.parse(localStorage.getItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.USER));
    currentUser.name = name;
    currentUser.surname = surname;
    currentUser.phone_number = phone;

    localStorage.setItem('user', JSON.stringify(currentUser));
    Vue.prototype.$store.user = currentUser;
  }

  isAdmin() {
    const roleId = Vue.prototype.$store.user.role_id;
    return roleId === 0 || roleId === 1 || roleId === 2 || roleId === 3 || roleId === 5;
  }

}

export default AuthService;
